import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Content = ({ className, children }: Props) => {
    return (
        <div
            className={cn(
                "tw:w-full tw:bg-background tw:p-6 tw:mb-4 tw:h-[clamp(20dvh,40rem,calc(100dvh-var(--spacing-header-height-desktop)-4rem))]",
                className
            )}
        >
            {children}
        </div>
    );
};
